import { useAtom } from "jotai"
import { userAtom } from "@/common/state"
import WindowSize from "@/common/WindowSize"
import DesktopNavBar from "@/components/navBar/DesktopNavBar"
import MobileNavBar from "@/components/navBar/MobileNavBar"
import dayjs from "dayjs"

import "@/components/navBar/navBar.css"

const NavBar = () => {
  const [user] = useAtom(userAtom)

  const currentDate = dayjs()

  if (user && dayjs(currentDate).isAfter(user?.expires)) {
    // removing user data once expired
    localStorage.removeItem("user")
    window.location.href = "/"
  }
  const windowSize = WindowSize()
  return (
    <>{windowSize.innerWidth <= 1025 ? <MobileNavBar /> : <DesktopNavBar />}</>
  )
}

export default NavBar
